import PropTypes from "prop-types";
const { string, number, oneOfType } = PropTypes;

export const ProductData = {
  brand: string.isRequired,
  productId: number.isRequired,
  productName: string.isRequired,
  siteId: oneOfType([string, number]),
  status: string.isRequired,
  website: string,
};
